<template>
  <soha-modal
    id="insertJobBoardLink"
    :title="modalTitle"
    size="lg"
    hide-footer
    @hide="clearModalData"
    @show="getJobBoards"
  >
    <template #body>
      <soha-page-loading v-if="loading" />
      <soha-no-access
        v-else-if="noAccess"
        :message="noAccess"
      />
      <div
        v-else
        class="job-boards"
      >
        <div v-if="jobBoardHasAccont">
          <div class="row m-0">
            <soha-select
              v-model="filterResult.jobBoardSelectId"
              name="jobBoardAccounts"
              class="w-100 my-3"
              :placeholder="$t(`${I18nPrefix}JOB_BOARD_SELECT`)"
              :options="filters"
              @on-change="changeOptions"
            />
          </div>
          <div class="row m-0">
            <soha-text-field
              v-model="filterResult.searchQuery"
              name="publishedJobsSearch"
              class="w-100 my-3"
              :placeholder="$t(`${I18nPrefix}PUBLISH_JOBS_SEARCH`)"
              icon="search"
              icon-position="left"
              @input="changeSearchQuery"
            />
          </div>
          <div
            ref="jobBoardsBox"
            class="row soha-job-boards-box"
          >
            <div
              v-for="(job, index) in selectedJobBoardsBinding"
              :key="index"
              class="col-12 my-2"
            >
              <soha-job-boards-job
                :job="job"
                :job-id="selectedJob.id"
              />
            </div>
            <infinite-loading
              class="mx-auto"
              :identifier="infiniteId"
              @infinite="getSelectedJobBoards"
            >
              <template #spinner>
                <div class="mt-8">
                  <loading size="12" />
                </div>
              </template>
              <template #no-more>
                <div class="soha-no-more">
                  <!-- {{ $t(`${I18nPrefix}NO_MORE_JOB`) }} -->
                </div>
              </template>
              <template #no-results>
                <div class="soha-no-more mb-2">
                  {{ $t(`${I18nPrefix}NO_JOB`) }}
                </div>
              </template>
            </infinite-loading>
          </div>
          <div class="row m-0">
            <div class="col-lg-6">
              <soha-checkbox
                v-model="filterResult.excludeExpired"
                :label="$t(`${I18nPrefix}NOT_SHOW_EXPIRED_JOB`)"
                true-value="1"
                false-value="0"
                checkbox-id="excludeExpired"
                @change="changeOptions"
              />
            </div>
            <div class="col-lg-6">
              <soha-checkbox
                v-model="filterResult.excludeConected"
                :label="$t(`${I18nPrefix}NOT_SHOW_CONECTED_JOB`)"
                true-value="1"
                false-value="0"
                checkbox-id="excludeConected"
                @change="changeOptions"
              />
            </div>
          </div>
          <!-- <div
            class="row m-0 text-center align-items-center justify-content-center"
          >
            <span class="mr-4">
              {{ $t(`${I18nPrefix}SHARE_NEW_JOB`) }}
            </span>
            <soha-button
              icon="refresh"
              outline
              height="35"
              :loading="updateLoading"
              :text="$t(`${I18nPrefix}UDPATE_LIST`)"
              name="updateList"
              @btn-click="updateList()"
            />
          </div> -->
        </div>
        <div v-else>
          <div class="row justify-content-center">
            <p class="soha-modal-text">
              {{
                $t(`${I18nPrefix}NOT_JOB_BOARD_INTEGRATE_TEXT_MODAL`, {
                  jobBoardName: jobBoardName,
                })
              }}
            </p>
          </div>
          <div class="row mx-auto justify-content-center mt-10">
            <div class="d-flex">
              <soha-button
                name="acceptDeleteModalBtn"
                class="mr-2"
                outline
                :text="$t(`${I18nPrefix}CANCEL`)"
                variant="danger"
                @btn-click="$modal.hide('insertJobBoardLink')"
              />
              <soha-button
                name="acceptRejectModalBtn"
                class="ml-2"
                :text="$t(`${I18nPrefix}GO_TO_SETTING`)"
                @btn-click="$router.push({ name: 'integration-job-board' })"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
  </soha-modal>
</template>

<script>
import ApiService from "@/core/services/api.service";
import UIMixin from "@/mixins/UIMixin";
import { mapGetters } from "vuex";
import SohaJobBoardsJob from "@/view/components/job/JobJobBoardsAd";
import "@/assets/css/components/job/job-integration-job-board.css";

export default {
  name: "JobIntegrationLink",

  components: {
    SohaJobBoardsJob,
  },

  mixins: [UIMixin],

  props: {
    selectedJob: {
      require: true,
      default: null,
      type: Object,
    },
    jobBoardSelectId: {
      default: null,
      type: [Number, String]
    },
  },
emits: ['update:jobBoardSelectId'],

  data() {
    return {
      I18nPrefix: "COMPONENTS.JOB.JOB_INTEGRATION_JOB_BOARDS.",
      btnLoading: false,
      loading: false,
      jobBoardHasAccont: true,
      noAccess: null,
      currentPage: 1,
      selectedJobBoardsBinding: [],
      updateLoading: false,
      filters: [
        {
          text: "همه حساب‌های جاب‌بورد",
          id: "0",
        },
        {
          text: "حساب‌های جابینجا",
          id: "-4",
        },
        {
          text: "حساب‌های ای‌استخدام",
          id: "-1",
        },
        {
          text: "حساب‌های جاب‌ویژن",
          id: "-3",
        },
      ],
      filterResult: {
        jobBoardSelectId: "0",
        searchQuery: "",
        excludeExpired: "1",
        excludeConected: "1",
        perPage: "10",
      },
      infiniteId: 0,
      interval: null,
      jobBoardName: null,
      integrateJobBoards: [],
      jobBoards: [
        { id: 1, name: "ای‌استخدام" },
        { id: 3, name: "جاب‌ویژن" },
        { id: 4, name: "جابینجا" },
      ],
    };
  },

  methods: {
    getSelectedJobBoards(state) {
      let isFirstPage = this.currentPage == 1;
      let nextPage = this.currentPage + 1;
      ApiService.post(
        `api/v2/jobs/${this.selectedJob.id}/jobBindings?page=${this.currentPage}`,
        this.filterResult
      ).then((data) => {
        if (!data.data.code) {
          if (isFirstPage) this.selectedJobBoardsBinding = [];
          if (data.data.jobBindings.data.length) {
            this.selectedJobBoardsBinding.push(...data.data.jobBindings.data);
            this.currentPage = nextPage;
            if (state) {
              setTimeout(() => {
                state.loaded();
              }, 2000);
            }
          } else if (state) {
            state.complete();
          }
        } else if (data.data.code == 403) {
          this.noAccess = data.data.message;
        } else {
          this.errorToast(data.data.message);
        }
      });
    },

    clearModalData() {
      this.filters = [
        {
          text: "همه حساب‌های جاب‌بورد",
          id: "0",
        },
        {
          text: "حساب‌های جابینجا",
          id: "-4",
        },
        {
          text: "حساب‌های ای‌استخدام",
          id: "-1",
        },
        {
          text: "حساب‌های جاب‌ویژن",
          id: "-3",
        },
      ];
      this.selectedJobBoardsBinding = [];
      this.currentPage = 1;
      this.filterResult = {
        jobBoardSelectId: "0",
        searchQuery: "",
        excludeExpired: "1",
        excludeConected: "1",
        perPage: "10",
      };
      this.$emit("update:jobBoardSelectId", null);
    },

    changeOptions() {
      this.$refs.jobBoardsBox.scrollTop = 0;
      this.currentPage = 1;
      this.infiniteId += 1;
    },

    changeSearchQuery() {
      if (this.interval) {
        clearInterval(this.interval);
      }
      this.currentPage = 1;
      this.interval = setInterval(() => {
        this.$refs.jobBoardsBox.scrollTop = 0;
        this.infiniteId += 1;
        this.getSelectedJobBoards();
        clearInterval(this.interval);
      }, 1000);
    },

    getJobBoards() {
      this.loading = true;
      ApiService.get(`api/v2/companies/${this.companyId}/job-boards`).then(
        (data) => {
          if (!data.data.code) {
            let integrateJobBoards = data.data.jobBoards.filter((item) => {
              return item.username;
            });
            this.jobBoardHasAccont = data.data.jobBoards.some((jobBoard) => {
              return jobBoard.id == this.jobBoardSelectId && jobBoard.username;
            });
            if (!this.jobBoardHasAccont) {
              this.loading = false;
              return;
            }
            this.integrateJobBoards = integrateJobBoards.map((jobBoard) => {
              return {
                ...jobBoard,
                id: jobBoard.accountId,
                text:
                  "حساب کاربری " + jobBoard.username + " در " + jobBoard.name,
              };
            });
          } else if (data.data.code == 403) {
            this.noAccess = data.data.message;
          } else {
            this.errorToast(data.data.message);
          }
          this.loading = false;
        }
      );
    },
  },

  computed: {
    ...mapGetters(["companyId"]),

    modalTitle() {
      return this.$t(`${this.I18nPrefix}TITLE`, {
        title: this.selectedJob?.title,
      });
    },
  },

  watch: {
    integrateJobBoards(newVal) {
      newVal.map((val) => {
        this.filters.push(val);
      });
    },

    jobBoardSelectId(newVal) {
      this.selectedJobBoardsBinding = [];
      this.filterResult.jobBoardSelectId = -newVal;
      if (newVal) {
        this.jobBoardName = this.jobBoards.find(
          (jobBoard) => jobBoard.id == newVal
        ).name;
      }
    },
  },
};
</script>
